import React from 'react';
import {Surcouche} from './CarteLeaflet.js';
import {CAUSE_COULEURS} from '../../tokens.js';
import {cleCouleurCause} from '../../selectors/variation.js';

// Lot 11 : légende du style Causes. `causes` : Map pavId -> {cle, baisse} (causeDominanteParPav) ; `pavs` : PAV affichés (filtres de la carte).

const LIGNES = [
    ['condamnee', 'Lavage impossible répété (borne condamnée)'],
    ['defaut', 'Défaut de trappe ou de porte'],
    ['retiree', 'Retirée (plus de collecte)'],
    ['nouvelle', 'Nouvelle borne (moins de 8 semaines)'],
    ['residuBaisse', 'Baisse de plus de 20 % sans cause connue'],
    ['residu', 'Sans écart notable'],
];

export default function CarteLegendeCauses({causes, pavs}) {
    const comptes = {};
    for (const p of pavs) {
        const info = causes.get(p.id);
        const cle = info ? cleCouleurCause(info) : 'residu';
        comptes[cle] = (comptes[cle] || 0) + 1;
    }
    return (
        <Surcouche
            role="group"
            aria-label="Légende des causes de variation"
            style={{left: 16, bottom: 116, background: 'rgba(255,255,255,.94)', border: '1px solid #D5DAE1', borderRadius: 12, padding: '8px 12px', fontSize: 11, color: '#2D333B', pointerEvents: 'none'}}
        >
            <div style={{fontWeight: 700, marginBottom: 4}}>Cause dominante sur la période</div>
            {LIGNES.map(([cle, libelle]) => (
                <div key={cle} style={{display: 'flex', alignItems: 'center', gap: 8, lineHeight: '16px'}}>
                    <span style={{width: 10, height: 10, borderRadius: '50%', background: CAUSE_COULEURS[cle], border: '1px solid rgba(33,48,103,.25)', display: 'inline-block'}}/>
                    <span style={{flex: '1 1 auto'}}>{libelle}</span>
                    <b>{comptes[cle] || 0}</b>
                </div>
            ))}
        </Surcouche>
    );
}
